"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateWebsiteRefundSalesforceSchema = void 0;
exports.CreateWebsiteRefundSalesforceSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        messageId: {
            type: 'string'
        },
        source: {
            type: 'string'
        },
        sonosId: {
            type: 'string'
        },
        orderActionDateTime: {
            type: 'string'
        },
        refundId: {
            type: 'string'
        },
        paymentMethodId: {
            type: 'string'
        },
        paymentId: {
            type: 'string'
        },
    },
    required: [
        'messageId',
        'sonosId',
        'refundId',
        'paymentMethodId',
        'paymentId',
    ],
    type: 'object'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlLXdlYnNpdGUtcmVmdW5kLXNhbGVzZm9yY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZG9tcy9zY2hlbWFzL3NhbGVzZm9yY2UvY3JlYXRlLXdlYnNpdGUtcmVmdW5kLXNhbGVzZm9yY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxtQ0FBbUMsR0FBRztJQUNsRCxPQUFPLEVBQUUseUNBQXlDO0lBQ2xELFVBQVUsRUFBRTtRQUNYLFNBQVMsRUFBRTtZQUNWLElBQUksRUFBRSxRQUFRO1NBQ2Q7UUFDRCxNQUFNLEVBQUU7WUFDUCxJQUFJLEVBQUUsUUFBUTtTQUNkO1FBQ0QsT0FBTyxFQUFFO1lBQ1IsSUFBSSxFQUFFLFFBQVE7U0FDZDtRQUNELG1CQUFtQixFQUFFO1lBQ3BCLElBQUksRUFBRSxRQUFRO1NBQ2Q7UUFDRCxRQUFRLEVBQUU7WUFDVCxJQUFJLEVBQUUsUUFBUTtTQUNkO1FBQ0QsZUFBZSxFQUFFO1lBQ2hCLElBQUksRUFBRSxRQUFRO1NBQ2Q7UUFDRCxTQUFTLEVBQUU7WUFDVixJQUFJLEVBQUUsUUFBUTtTQUNkO0tBQ0Q7SUFDRCxRQUFRLEVBQUU7UUFDVCxXQUFXO1FBQ1gsU0FBUztRQUNULFVBQVU7UUFDVixpQkFBaUI7UUFDakIsV0FBVztLQUNYO0lBQ0QsSUFBSSxFQUFFLFFBQVE7Q0FDZCxDQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IENyZWF0ZVdlYnNpdGVSZWZ1bmRTYWxlc2ZvcmNlU2NoZW1hID0ge1xuXHQkc2NoZW1hOiAnaHR0cDovL2pzb24tc2NoZW1hLm9yZy9kcmFmdC0wNy9zY2hlbWEjJyxcblx0cHJvcGVydGllczoge1xuXHRcdG1lc3NhZ2VJZDoge1xuXHRcdFx0dHlwZTogJ3N0cmluZydcblx0XHR9LFxuXHRcdHNvdXJjZToge1xuXHRcdFx0dHlwZTogJ3N0cmluZydcblx0XHR9LFxuXHRcdHNvbm9zSWQ6IHtcblx0XHRcdHR5cGU6ICdzdHJpbmcnXG5cdFx0fSxcblx0XHRvcmRlckFjdGlvbkRhdGVUaW1lOiB7XG5cdFx0XHR0eXBlOiAnc3RyaW5nJ1xuXHRcdH0sXG5cdFx0cmVmdW5kSWQ6IHtcblx0XHRcdHR5cGU6ICdzdHJpbmcnXG5cdFx0fSxcblx0XHRwYXltZW50TWV0aG9kSWQ6IHtcblx0XHRcdHR5cGU6ICdzdHJpbmcnXG5cdFx0fSxcblx0XHRwYXltZW50SWQ6IHtcblx0XHRcdHR5cGU6ICdzdHJpbmcnXG5cdFx0fSxcblx0fSxcblx0cmVxdWlyZWQ6IFtcblx0XHQnbWVzc2FnZUlkJyxcblx0XHQnc29ub3NJZCcsXG5cdFx0J3JlZnVuZElkJyxcblx0XHQncGF5bWVudE1ldGhvZElkJyxcblx0XHQncGF5bWVudElkJyxcblx0XSxcblx0dHlwZTogJ29iamVjdCdcbn1cbiJdfQ==